module.exports = __webpack_public_path__ + "img/下汤镇.d9b09bf0.png";